import { ProductExternal } from '@nemuru-eng/js-api-client';

export const PRODUCT_EXTERNAL_VALUES = [
  ProductExternal.CONSUMER_LOAN,
  ProductExternal.AUTO,
  ProductExternal.CREDIT_LINE,
  ProductExternal.BNPL,
  ProductExternal.PAY_BY_LINK,
];
